import { render, staticRenderFns } from "./associationEdit.vue?vue&type=template&id=10216c92&scoped=true&"
import script from "./associationEdit.vue?vue&type=script&lang=js&"
export * from "./associationEdit.vue?vue&type=script&lang=js&"
import style0 from "./associationEdit.vue?vue&type=style&index=0&id=10216c92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10216c92",
  null
  
)

export default component.exports